<template>
    <div class="dp-ib mg-l-6 mg-r-6">
        <a :href="data.url" :title="data.title" class="dp-fx fx-dr-col wd-full wht-sp-normal">
            <div :style="{'background-image': `url(${(data.image !== '') ? data.image : defaultImage})`}" class="img" :alt="data.title" :title="data.title"></div>
            <div class="mg-t-6 dp-fx fx-al-ct cl-white">
                <div :class="`dp-fx fx-al-ct pd-t-6 pd-b-6 pd-l-10 pd-r-10 br-rd-5 nepo-gradient ${data.decision}`">
                    <img v-if="data.decision=='up'" src="@/assets/heart.png" height=18 />
                    <img v-else src="@/assets/heart-broken.png" height=18 />
                    <span class="mg-l-6 fz-20">{{data.ratings}}</span>
                    <span class="fz-12">/10</span>
                </div>
            </div>
            <p class="mg-t-6 fz-14 lh-20 fw-7">{{data.title}}</p>
        </a>
    </div>
</template>

<script>
    export default {
        name : 'RectangularTileImage',
        props : {
            data : Object
        },
        data : function () {
            return {
                defaultImage : require('../assets/default-movie-poster.png')
            }
        },
        methods : {}
    }
</script>

<style>

</style>